/* eslint-disable max-len */
export const splitUrl = /(\/)(?=[^/]*$)/;
export const emailRegExp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/; // Validace emailu
export const phoneNumberRegExp = /^(\+|00)?[1-9][0-9]{8,14}$/; // Validace tel. čísla
export const phoneNumberNoCountryCodeRegExp = /^[0-9]{6,14}$/; // Validace tel. čísla
export const passwordRegExp = /(?=.*[A-Z]+)(?=.*[a-z]+)(?=.*[0-9]+)(?=^.{8,128}$)/; // Validace hesla (min 8 znaků, velká a malá písmena)
export const icoRegExp = /^[0-9]{8}$/; // Validace iča
export const icoZahranicnyRegExp = /(?=^.{3,30}$)(?=^(([0-9a-zA-ZΗΕ]+)|(([0-9a-zA-ZΗΕ]+[-/. ]){1,2}[0-9a-zA-ZΗΕ]+))$)/; // Validace zahranicneho iča
export const nidRegExp = /^[0-9]{10}$/; // Validace nid
export const rodneCisloRegExp = /^[0-9]{2}([0257][1-9]|[1368][0-2])([0][1-9]|[12][0-9]|[3][01])[0-9]{3,4}$/; // Validace rodneho cisla
export const leiRegExp = /^[A-Z0-9]{20}$/; // Validace LEI
export const procentaRegExp = /^(100(?:[.,]0+)?|[0-9]{1,2}(?:[.,][0-9]{0,2})?)?$/; // 0.00 - 100.00%
export const procentaRegExp6 = /^(100(?:[.,]0+)?|[0-9]{1,2}(?:[.,][0-9]{0,6})?)?$/; // 0.00 - 100.00%
export const zakladnyKapitalRegExp = /^\d{0,13}(?:[.,]\d{0,2})?/; // pouzite v ISINe
export const iBanCountry = /^([A-Z]{2})(\d{2})([A-Z\d]+)$/; // sucast iban validacie
export const dicIneZemeRegExp = /^[A-Z]{2}[A-Z0-9]{1,13}$/; // dic cizí země
export const dicCzRegExp = /^CZ([0-9]{8,10})$/; // dic cz
export const cisloOnly20RegExp = /^[0-9]{0,20}$/;
export const cislaOnly = /^[0-9]*$/;
export const cisloDecimalOnly30RegExp = /^[0-9,.]{0,30}$/;
export const dveDesetinneMistaRegExp = /^\d*(?:[.,]\d{0,2})?$/; // kontrola 2 desetinne mista
export const naceRegExp = /^[0-9]{2}$/; // pouzite v isine
// eslint-disable-next-line max-len
export const eurlTestRegExp =
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/; // validacia URL
// eslint-disable-next-line max-len
export const globalInputRegExp =
    /^(?!.*[„“])[a-zA-Z\dÀ-ÖØ-öø-ɏΗΕ'()[\]{},.;\\/\-–+:!@#$§%^*?_=|&<>"]+(\s[a-zA-Z\dÀ-ÖØ-öø-ɏΗΕ'()[\]{},.;\\/\-–+:!@#$§%^*?_=|&<>"]+)*\s*$/; // kontrola nevalidnych znakov
export const formatMoneyAmount = /\B(?=(\d{3})+(?!\d))/g; // pouzite pri formatovani cisel na napr: 1000 => 1 000 ...
export const strinTranslateParamsRegExp = /{{( *\w*)*}}/; // pouzite pri translateText
export const ceskePscRegExp = /^[0-9]{3}[ ]?[0-9]{2}$/;
export const rcmaRegExp = /^[1-9][0-9]{11}$/g;
export const rcmaRegExpSimple = /^[0-9A-Z/-]{1,12}$/g;
export const pismenaCislaRegExp = /^[a-zA-Z0-9]{1,50}$/g;
export const cisloBankyRegExp = /^[0-9]{4}$/;
export const dltUcetRegExp = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
export const smsKodRegExp = /^ISB-[1-9][0-9]{7}$/;
export const ciisKodRegExp = /^[A-Z0-9]{6}\.[A-Z0-9]{5}\.[A-Z0-9]{2}\.[A-Z0-9]{3}$/;

// dynamický regex kontrolující počet číslic dle zadaných parametrů
export const pocetCislic = (min: number, max?: number) => {
    return new RegExp(`^\\d{${min},${max ? max : min}}$`, 'g');
};
